import { Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CoreTargetService } from 'src/app/core/services/target.service';
import { LocalStorageService } from '../core/services/local-storage.service';
import { FORCE_REGION } from '../core/http/http-context.tokens';

@Injectable({
  providedIn: 'root',
})
export class TargetService {
  constructor(
    private http: HttpClient,
    private coreTargetService: CoreTargetService,
    private localStorageService: LocalStorageService,
  ) {}

  getTargetList(region?: string): Observable<any> {
    if (region) {
      return this.http.get<any>('/targets', {
        context: new HttpContext().set(FORCE_REGION, region),
      });
    } else {
      return this.http.get<any>('/targets');
    }
  }

  getCurrentUserRoles(email: any): Observable<any> {
    let params = 'email=' + email;
    if (this.coreTargetService.getSelectedTarget('target')) {
      params += '&target=' + this.coreTargetService.getSelectedTarget('target');
    }

    return this.http.get('/privileges/userPrivileges/user?' + params);
  }

  updateGa4Status(target: any, status: any) {
    return this.http.put('/change-ga4-status', {
      target: target,
      status: status,
    });
  }

  getFavoriteTargets(): Observable<any> {
    const email = this.localStorageService.get('email');
    return this.http.get<any>('/getFavoriteTargets?email=' + email, {
      context: new HttpContext().set(FORCE_REGION, 'west-eu'),
    });
  }
  addTargetToFavorites(target: string): Observable<any> {
    const email = this.localStorageService.get('email');
    return this.http.post<any>(
      '/addTargetToFavorites',
      {
        email: email,
        target: target,
      },
      {
        context: new HttpContext().set(FORCE_REGION, 'west-eu'),
      },
    );
  }
  deleteTargetToFavorites(target: string): Observable<any> {
    const email = this.localStorageService.get('email');
    return this.http.delete<any>(
      `/deleteTargetToFavorites?email=${email}&target=${target}`,
      {
        context: new HttpContext().set(FORCE_REGION, 'west-eu'),
      },
    );
  }
}
